module.exports = __webpack_public_path__ + "img/google-icon.abd2ea4e.svg";